
import { Vue, Component } from "vue-property-decorator";
import { UFFeedback } from "@/utils/literals/feedback";
import { assetsUrl } from "@/env";
import { FeedbackType } from "@/schemas/Enums";
import { mapState } from "vuex";

@Component({
  computed: {
    ...mapState("session", ["session"]),
  },
})
export default class Intro extends Vue {
  getUFFb(key: string): string {
    return UFFeedback[key] || "";
  }
  getImgUrl(fileName: string): string {
    return `${assetsUrl}/svg/${fileName}`;
  }
  // La fonction d'après sert a savoir si c'est le vieux FB ou le nouveau en moyenne, et atm on force que ce soit toujours en moyenne, pour tout le monde, même si la BDD dit le contraire
  get displayAvgFeedback(): boolean {
    // if (this.session.setting) {
    //   let settings = this.session.setting.feedback_details.find(
    //     (setting: {
    //       type: FeedbackType;
    //       display_feedback_message: boolean;
    //       display_score?: boolean;
    //       display_indiv_scores?: boolean;
    //       display_group_score?: boolean;
    //       display_avg_feedback?: boolean;
    //     }) => setting.type === FeedbackType.Performance
    //   );
    //   return settings ? settings.display_avg_feedback : false;
    // }
    // return false;
    return true;
  }
}
